'use client';

import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import InteractiveMapDesktop from '@components/architecture/a-interactive-map/InteractiveMapDesktop';
import BreadCrumbs from '@components/breadcrumbs/BreadCrumbs';
import ROUTES from '@lib/constants/routes';
import { visibleScrollSelector } from '@lib/store/slices/ComponentsSlice';
import ScrollHelperTransTwo from '@lib/tools/helpers/ScrollHelperTransTwo';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { animated, useSpring } from '@react-spring/web';
import { ScrollTrigger } from 'gsap/all';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import style from './page.module.scss';
function TemplateAbout(t0) {
  const $ = _c(37);
  const {
    children
  } = t0;
  const [toggle2, setToggle2] = useState(false);
  const [toggle3, setToggle3] = useState(false);
  const svgRef2 = useRef(null);
  const svgRef3 = useRef(null);
  const st2Ref = useRef(null);
  const st3Ref = useRef(null);
  const timeoutRef = useRef(null);
  const {
    isMobile,
    viewport
  } = useViewport();
  const t1 = !isMobile ? "white" : "#1C1C1C";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      id: 1,
      text: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
      link: ROUTES.root
    }, {
      id: 2,
      text: "\u041E \u043F\u0440\u043E\u0435\u043A\u0442\u0435"
    }];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = {
      color: t1,
      crumbs: t2
    };
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const breadCrumbsApi = t3;
  const visibleScroll = useSelector(visibleScrollSelector);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 500
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = visibleScroll ? 0 : 1;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      config: t4,
      opacity: t5,
      delay: 0
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const opacityStyle = useSpring(t6);
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      duration: 10
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = !visibleScroll ? 1 : 0;
  let t9;
  if ($[7] !== t8) {
    t9 = {
      config: t7,
      opacity: t8,
      delay: 0
    };
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const opacityStyleRevers = useSpring(t9);
  let t10;
  if ($[9] !== isMobile) {
    t10 = () => {
      const initializeScrollTriggers = () => {
        const element2 = svgRef2.current;
        const element3 = svgRef3.current;
        if (!element2 || !element3) {
          return;
        }
        st2Ref.current = ScrollTrigger.create({
          trigger: element2,
          start: "top top",
          scroller: !isMobile ? "#smooth-wrapper" : "body",
          duration: 1,
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle2(true);
            }, 400);
          }
        });
        st3Ref.current = ScrollTrigger.create({
          trigger: element3,
          start: "top top",
          scroller: !isMobile ? "#smooth-wrapper" : "body",
          duration: 1,
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle3(true);
            }, 500);
          }
        });
      };
      timeoutRef.current = setTimeout(() => {
        initializeScrollTriggers();
      }, 1000);
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        if (st2Ref.current) {
          st2Ref.current.kill();
          st2Ref.current = null;
        }
        if (st3Ref.current) {
          st3Ref.current.kill();
          st3Ref.current = null;
        }
      };
    };
    $[9] = isMobile;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== isMobile || $[12] !== viewport) {
    t11 = [svgRef2, svgRef3, isMobile, viewport];
    $[11] = isMobile;
    $[12] = viewport;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  useEffect(t10, t11);
  const t12 = visibleScroll ? opacityStyleRevers : opacityStyle;
  let t13;
  if ($[14] !== breadCrumbsApi) {
    t13 = <div className={style.bredCrumbs_block}><BreadCrumbs item={breadCrumbsApi} /></div>;
    $[14] = breadCrumbsApi;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== isMobile) {
    t14 = isMobile && <h1 className={style.title}>Квартал для красивой <br />линии жизни</h1>;
    $[16] = isMobile;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== isMobile) {
    t15 = <InteractiveMapDesktop isMobile={isMobile} />;
    $[18] = isMobile;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== isMobile || $[21] !== toggle2 || $[22] !== toggle3) {
    t16 = !isMobile && <><div className={style.aboutDesktop} ref={svgRef2}><AnimateLines id="about-desktop" className={style.aboutDesktopSvg} toggle={toggle2} /></div><div className={style.aboutGreenLine} ref={svgRef3}><AnimateLines id="about-green-oasis-line" className={style.aboutGreenLineSvg} toggle={toggle3} /></div></>;
    $[20] = isMobile;
    $[21] = toggle2;
    $[22] = toggle3;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== isMobile || $[25] !== toggle2 || $[26] !== toggle3) {
    t17 = isMobile && <><div className={style.aboutMobile} ref={svgRef2}><AnimateLines id="about-mobile" className={style.aboutMobileSvg} toggle={toggle2} /></div><div className={style.aboutMobileQueue} ref={svgRef3}><AnimateLines id="about-mobile-queue" className={style.aboutMobileQueueSvg} toggle={toggle3} /></div></>;
    $[24] = isMobile;
    $[25] = toggle2;
    $[26] = toggle3;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ScrollHelperTransTwo />;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== children || $[30] !== t12 || $[31] !== t13 || $[32] !== t14 || $[33] !== t15 || $[34] !== t16 || $[35] !== t17) {
    t19 = <><animated.div style={t12}>{t13}{t14}{t15}{t16}{t17}{children}{t18}</animated.div></>;
    $[29] = children;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  return t19;
}
export default TemplateAbout;